module.exports = __webpack_public_path__ + "static/media/mark-merner-ZK69PVQj5nc-unsplash.e5a3957d.jpg";